module.exports = __webpack_public_path__ + "img/mixer_img@2x.7db6ddb0.png";